import AdditionalInfoView from "./additionalInfoView"

export default AdditionalInfoView
